// SB NOTE: WidgetSources has the custom dropdown with arrow keys selector that could be transformed into component

function scrollIntoViewIfNeeded(wrapper, target) {
  const rectParent = wrapper ? wrapper.getBoundingClientRect() : target.parentElement.getBoundingClientRect();
  const rect = target.getBoundingClientRect();
  const pseudoElementStyle = getComputedStyle(wrapper || target.parentElement);
  const borderTopWidth = Number.parseInt(pseudoElementStyle.borderTopWidth.replace('px', ''), 10);
  const topPadding = Number.parseInt(pseudoElementStyle.paddingTop.replace('px', ''), 10);
  const parentTop = rectParent.top + borderTopWidth + topPadding;
  const parentBottom = rectParent.bottom + borderTopWidth + topPadding;
  if (rect.top < parentTop) {
    target.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
  } else if (rect.bottom > parentBottom) {
    target.scrollIntoView({ block: 'end', inline: 'nearest', behavior: 'smooth' });
  }
}

export { scrollIntoViewIfNeeded };
